export default __webpack_public_path__ + "static/media/cat-01.5f84bec9.jpg";